import type {
  OnboardingRequirement,
  OnboardingRequirementCollectBusinessData,
  OnboardingRequirementCollectCustomData,
  OnboardingRequirementCollectDocument,
  OnboardingRequirementProcess,
  OnboardingRequirementRegisterPasskey,
  OnboardingRequirementSleep,
} from '@onefootprint/request-types';

type OnboardingRequirementKind = OnboardingRequirement['kind'];

type RequirementForKind<K> = K extends 'liveness'
  ? OnboardingRequirementRegisterPasskey
  : K extends 'collect_document'
    ? OnboardingRequirementCollectDocument
    : K extends 'collect_business_data'
      ? OnboardingRequirementCollectBusinessData
      : K extends 'process'
        ? OnboardingRequirementProcess
        : K extends 'collect_custom_data'
          ? OnboardingRequirementCollectCustomData
          : K extends 'sleep'
            ? OnboardingRequirementSleep
            : never;

export const getRequirement = <K extends OnboardingRequirementKind>(reqs: OnboardingRequirement[], kind: K) =>
  getRequirements(reqs, kind)[0];

export const getRequirements = <K extends OnboardingRequirementKind | string>(reqs: OnboardingRequirement[], kind: K) =>
  reqs.filter(req => req.kind === kind).map(req => req as RequirementForKind<K>);
